import React, { useState, useCallback, useEffect } from 'react';
import { Chart, Series, Legend, ValueAxis, CommonSeriesSettings, Tooltip } from 'devextreme-react/chart';
import { groupBy, calcWeightData } from '../../utils/miscUtil';
import { TagBox } from 'devextreme-react/tag-box';
import { SelectBox } from 'devextreme-react/select-box';
import notify from 'devextreme/ui/notify';
import './Charts.scss';

const palette = ["rgba(20, 77, 109, 1)", "rgba(236, 80, 32, 1)", "rgba(92, 194, 215, 1)", "rgba(0, 162, 200, 1)", "rgba(20, 77, 109, 0.4)", "rgba(236, 80, 32, 0.4)", "rgba(92, 194, 215, 0.4)", "rgba(0, 162, 200, 0.4)"]

export default function HSEEmissions(props) {
  const [allCompaniesList, setAllCompaniesList] = useState([]);
  const [selectedCompaniesList, setSelectedCompaniesList] = useState([]);
  const [selectedYear, setSelectedYear] = useState([]);
  const [data, setData] = useState([]);
  const [weight, setWeight] = useState("Oil & Gas Weighted");
  const [weightData, setWeightData] = useState({});
  const [data2, setData2] = useState([]);
  const [methodology, setMethodology] = useState("All");
  const [dataByEmissionTypePercentage, setDataByEmissionTypePercentage] = useState([]);
  const [dataByEmissionType, setDataByEmissionType] = useState([]);
  const [methodologyChoices, setMethodologyChoices] = useState([]);
  const [absoluteData, setAbsoluteData] = useState([]);

  useEffect(() => {
    setSelectedYear(props.year);
  }, [props.year]);

  useEffect(() => {
    setWeightData(calcWeightData(props.data, props.year));
    console.log(calcWeightData(props.data, props.year));
    
  }, [props.data, props.year]);

  useEffect(() => {
    const methodologyData = props.data.filter(e => e.Identifier === "153" && e.year === selectedYear.toString());
    const choices = ["All", ...Object.keys(groupBy(methodologyData, 'value')).sort()];
    setMethodologyChoices(choices);
    if (!choices.includes(methodology)) {
        setMethodology("All");
    }
  }, [props.data, selectedYear, methodology]);
  useEffect(() => {
    var fd = [];
    var fd1 = [];
    var i = 0;
    let missingCompanyCounter = 1;

    fd1 = groupBy(props.data, 'company_name')
    setAllCompaniesList(Object.keys(fd1).sort())

    var originalData = props.data
    if (selectedCompaniesList.length > 0) {
      originalData = originalData.filter((it) => selectedCompaniesList.includes(it['company_name']));
    }

    if (methodology !== "All") {
      const methodologyCompanies = props.data
        .filter(e => e.Identifier === "153" && e.year === selectedYear.toString() && e.value === methodology)
        .map(e => e.company_id);
      originalData = originalData.filter(it => methodologyCompanies.includes(it.company_id));
    }
    
    const identifiers = [
      "154", "146", "147", "148", "149", "150", "151", "152"
    ];

    fd = originalData.filter(
      (e) =>
        identifiers.includes(e["Identifier"]) && e["year"] === selectedYear.toString() && e["value"] &&
        weight.includes(weightData[e["company_id"]])
    );
    
    fd = groupBy(fd,"company_id");
    const sortedCompanyIds = Object.keys(fd).sort((a, b) => {
      const totalA = fd[a].reduce((sum, item) => {
        const parsedValue = parseFloat(item['value']?.replace(/,/g, '').replace(/ /g, ''));
        return sum + (isNaN(parsedValue) ? 0 : parsedValue);
      }, 0);
      const totalB = fd[b].reduce((sum, item) => {
        const parsedValue = parseFloat(item['value']?.replace(/,/g, '').replace(/ /g, ''));
        return sum + (isNaN(parsedValue) ? 0 : parsedValue);
      }, 0);
      return totalA - totalB;
    });
    const fd_abs = sortedCompanyIds.map((key) => {
      if (fd[key].length >= identifiers.length) {
        let r = {};
        r.name = fd[key]['0']['company_name'];
        if (!r.name || r.name === 'null') {
          r.name = `COMPANY ${missingCompanyCounter++}`;
        }
        for (i=0; i<fd[key].length; i++) {
          try {
            const metricName = fd[key][i]['Details'].split('(')[0].trim().replace('Emissions from ', '');
            const parsedValue = parseFloat(fd[key][i]['value'].replace(/,/g, '').replace(/ /g, ''));
            if (isNaN(parsedValue)) {
              notify(`Invalid numeric value '${fd[key][i]['value']}' for company '${fd[key][i]['company_name']}'`, 'error', 5000);
            }
            r[metricName] = parsedValue;
          } catch (error) {
            notify("Incorrect metric name '"+fd[key][i]['Details']+"' for company '"+fd[key][i]['company_name']+"'. Metric name should include ':'", 'error', 5000);
            break
          }
        }
        return r
      }
      return null;
    }).filter(Boolean);
    setAbsoluteData(fd_abs);

    const fd_by_emission = {};
    fd_abs.forEach(companyData => {
      const companyName = companyData.name;
      Object.keys(companyData).forEach(metric => {
        if (metric !== 'name') {
          if (!fd_by_emission[metric]) {
            fd_by_emission[metric] = {
              emissionType: metric,
              total: 0
            };
          }
          const value = companyData[metric] || 0;
          fd_by_emission[metric][companyName] = value;
          fd_by_emission[metric].total += value;
        }
      });
    });
    let dataByEmission = Object.values(fd_by_emission);

    dataByEmission.sort((a, b) => a.total - b.total);

    const percentageData = dataByEmission.map(item => {
      const newItem = { emissionType: item.emissionType, total: 1 };
      Object.keys(item).forEach(key => {
        if (key !== 'emissionType' && key !== 'total') {
          if (item.total > 0) {
            newItem[key] = item[key] / item.total;
          } else {
            newItem[key] = 0;
          }
        }
      });
      return newItem;
    });

    setDataByEmissionTypePercentage(percentageData);

    setDataByEmissionType(dataByEmission);


    fd1 = {};
    missingCompanyCounter = 1;
    fd = sortedCompanyIds.map((key) => {
      if (fd[key].length >= identifiers.length) {
        let r = {};
        r.name = fd[key]['0']['company_name'];
        if (!r.name || r.name === 'null') {
          r.name = `COMPANY ${missingCompanyCounter++}`;
        }
        let total = 0
        for (i=0; i<fd[key].length; i++) {
          const parsedValue = parseFloat(fd[key][i]['value'].replace(/,/g, '').replace(/ /g, ''));
          if (isNaN(parsedValue)) {
            notify(`Invalid numeric value '${fd[key][i]['value']}' for company '${fd[key][i]['company_name']}'`, 'error', 5000);
          }
          total = total + (parsedValue || 0);
        }
        for (i=0; i<fd[key].length; i++) {
          try {
            const metricName = fd[key][i]['Details'].split("(")[0].trim().replace('Emissions from ', '');
            const parsedValue = parseFloat(fd[key][i]['value'].replace(/,/g, '').replace(/ /g, ''));
            if (isNaN(parsedValue)) {
              notify(`Invalid numeric value '${fd[key][i]['value']}' for company '${fd[key][i]['company_name']}'`, 'error', 5000);
            }
            r[metricName] = (parsedValue || 0)/total
            fd1[metricName] = 1
          } catch (error) {
            notify("Incorrect metric name '"+fd[key][i]['Details']+"' for company '"+fd[key][i]['company_name']+"'. Metric name should include ':'", 'error', 5000);
            break
          }
        }
        return r
      }
      return null;
    }).filter(Boolean);

    setData(fd);

    setData2(Object.keys(fd1))
    

  }, [props.data, selectedYear, selectedCompaniesList, weight, weightData, methodology]);

  const onCompaniesChanged = useCallback((e) => {
    setSelectedCompaniesList(e.value);
  }, [setSelectedCompaniesList])

  const customizeTooltip = useCallback((pointInfo) => {
    var txt = ''
    if (pointInfo.total !== undefined) {
      txt = `<div><div class="tooltip-header">${pointInfo.argumentText}</div><div class="tooltip-body">`
      for (var i=0; i<pointInfo.points.length; i++) {
        txt = txt+`<div>${pointInfo.points[i].seriesName}: ${pointInfo.points[i].percentText}</div>`
      }
      txt=txt+`</div></div>`
    }
    return {
      html: txt,
    }
  }, []);

  const customizeTooltipAbs = useCallback((pointInfo) => {
    var txt = ''
    if (pointInfo.total !== undefined) {
      txt = `<div><div class="tooltip-header">${pointInfo.argumentText} - Total: ${pointInfo.totalText}</div><div class="tooltip-body">`
      for (var i=0; i<pointInfo.points.length; i++) {
        txt = txt+`<div>${pointInfo.points[i].seriesName}: ${pointInfo.points[i].valueText}</div>`
      }
      txt = txt+`</div></div>`
    }
    return { html: txt };
  }, []);

  const onYearChanged = useCallback((e) => {
    setSelectedYear(e.value);
  }, [setSelectedYear])

  const onWeightChanged = useCallback((e) => {
    setWeight(e.value);
  }, [setWeight])

  const onMethodologyChanged = useCallback((e) => {
    setMethodology(e.value);
  }, [setMethodology]);

  return (
    <>
    <h4>Emissions Breakdown in {selectedYear} </h4>
    <div className="d-flex flex-row">
      <TagBox
          dataSource={allCompaniesList}
          value={selectedCompaniesList}
          showDropDownButton={true}
          width="100%"
          activeStateEnabled={true}
          multiline={false}
          showSelectionControls={true}
          onValueChanged={onCompaniesChanged}
          label={"Company"}
          labelMode="floating"
          placeholder={"Select Companies"}
      />
      <div className="mx-1"/>
      <SelectBox
          dataSource={[props.year, (parseInt(props.year)-1).toString(), (parseInt(props.year)-2).toString()]}
          value={selectedYear}
          width="250px"
          showDropDownButton={true}
          activeStateEnabled={true}
          onValueChanged={onYearChanged}
          label={"Year"}
          labelMode="floating"
          placeholder={"Year"}
      />
      <div className="mx-1"/>
      <SelectBox
          dataSource={["Gas Weighted", "Oil Weighted", "Oil & Gas Weighted"]}
          value={weight}
          width="350px"
          showDropDownButton={true}
          activeStateEnabled={true}
          onValueChanged={onWeightChanged}
          label={"Gas/Oil Weighted"}
          labelMode="floating"
          placeholder={"Gas/Oil Weighted"}
      />
      <div className="mx-1"/>
      <SelectBox
          dataSource={methodologyChoices}
          value={methodology}
          width="350px"
          showDropDownButton={true}
          activeStateEnabled={true}
          onValueChanged={onMethodologyChanged}
          label={"Methodology"}
          labelMode="floating"
          placeholder={"Select Methodology"}
      />
    </div>
    <hr className={'mb-4'}/>
    <div className="d-flex flex-column justify-content-between w-100">
      <Chart
        title="Relative Emissions"
        id="chart"
        dataSource={data}
        barGroupWidth={20}
        rotated={true}
        height={(data.length*30).toString()+"px"}
        palette={palette}
      >
        <CommonSeriesSettings
          argumentField="name"
          type="stackedbar"
        >
        </CommonSeriesSettings>

        {data2.map((e) => (<Series
          key={e}
          valueField={e}
          name={e}
          ignoreEmptyPoints={true}
        />))}

        <ValueAxis showZero={false} />
        <Legend visible={true} />
        <Tooltip
          enabled={true}
          shared={true}
          customizeTooltip={customizeTooltip}
          format={{type: "percent", precision: 2}}
        />
      </Chart>
    </div>
    <div className="d-flex flex-column justify-content-between w-100">
      <Chart
        title="Total Emissions"
        id="chart-abs"
        dataSource={absoluteData}
        barGroupWidth={20}
        rotated={true}
        height={(absoluteData.length*30).toString()+"px"}
        palette={palette}
      >
        <CommonSeriesSettings
          argumentField="name"
          type="stackedbar"
        >
        </CommonSeriesSettings>

        {data2.map((e) => (<Series
          key={e}
          valueField={e}
          name={e}
          ignoreEmptyPoints={true}
        />))}

        <ValueAxis showZero={false} />
        <Legend visible={true} />
        <Tooltip
          enabled={true}
          shared={true}
          customizeTooltip={customizeTooltipAbs}
          format={{type: "fixedPoint", precision: 0}}
        />
      </Chart>
    </div>
    <div className="d-flex flex-column justify-content-between w-100">
      <Chart
        title="Relative Emissions by Type"
        id="chart-by-emission-type-percentage"
        dataSource={dataByEmissionTypePercentage}
        barGroupWidth={20}
        rotated={true}
        height={(dataByEmissionTypePercentage.length * 50).toString() + "px"}
        palette={palette}
      >
        <CommonSeriesSettings
          argumentField="emissionType"
          type="stackedbar"
        >
        </CommonSeriesSettings>

        {absoluteData.map((c) => (<Series
          key={c.name}
          valueField={c.name}
          name={c.name}
          ignoreEmptyPoints={true}
        />))}

        <ValueAxis showZero={false} />
        <Legend visible={true} />
        <Tooltip
          enabled={true}
          shared={true}
          customizeTooltip={customizeTooltip}
          format={{ type: "percent", precision: 2 }}
        />
      </Chart>
    </div>
    <div className="d-flex flex-column justify-content-between w-100">
      <Chart
        title="Total Emissions by Type"
        id="chart-by-emission-type"
        dataSource={dataByEmissionType}
        barGroupWidth={20}
        rotated={true}
        height={(dataByEmissionType.length * 50).toString() + "px"}
        palette={palette}
      >
        <CommonSeriesSettings
          argumentField="emissionType"
          type="stackedbar"
        >
        </CommonSeriesSettings>

        {absoluteData.map((c) => (<Series
          key={c.name}
          valueField={c.name}
          name={c.name}
          ignoreEmptyPoints={true}
        />))}

        <ValueAxis showZero={false} />
        <Legend visible={true} />
        <Tooltip
          enabled={true}
          shared={true}
          customizeTooltip={customizeTooltipAbs}
          format={{ type: "fixedPoint", precision: 0 }}
        />
      </Chart>
    </div>
    </>
  );
}